import { zodTransformFirestoreTimestampToDate } from "../utils/zodUtils.mjs";
import { zodFlavorId } from "./ids.mjs";
import { defineFirestoreCollection } from "./firebaseCollectionSchema.mjs";
import { paymentMethodInputSnapshotSchema } from "../paymentMethod/snapshot.mjs";
import { z as z$1 } from "zod";

// src/models/paymentMethodInputs.ts
/**
* Cached payment-method input snapshot for a customer (recomputed from source docs when missing).
* Path: payment_method_inputs/{customerId}
*/
const paymentMethodInputCacheDocumentSchema = paymentMethodInputSnapshotSchema.extend({
	id: zodFlavorId(),
	updatedAt: z$1.any().transform(zodTransformFirestoreTimestampToDate)
});
const PaymentMethodInputsCache = defineFirestoreCollection("payment_method_inputs", paymentMethodInputCacheDocumentSchema);
/** Strip Firestore metadata fields for use with `paymentMethodFromSnapshot`. */
function snapshotFromPaymentMethodInputCacheDocument(doc) {
	const { id, updatedAt, ...rest } = doc;
	return paymentMethodInputSnapshotSchema.parse(rest);
}

export { PaymentMethodInputsCache, paymentMethodInputCacheDocumentSchema, snapshotFromPaymentMethodInputCacheDocument };
//# sourceMappingURL=paymentMethodInputs.mjs.map